export default __webpack_public_path__ + "static/Los-Angeles-1a836d963678abb34346eb2bc15b76fc.webp";